var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-options"},[_c('span',{staticClass:"copyright"},[_c('span',{staticClass:"symbol"},[_vm._v("©")]),_vm._v(" riseup")])])])
}]

export { render, staticRenderFns }